import { connect } from 'react-redux';
import IOC from './components/IOC';
import {
  exportSingleIOC,
  loadScoreDetails,
  loadNewScoreDetails,
  toggleFalsePositive,
  toggleTruePositive,
} from '../../redux/actions/ioc';

const mapStateToProps = (state) => ({
  status: state.ioc.detailsStatus,
  newDetailsStatus: state.ioc.newDetailsStatus,
  scoreDetails: state.ioc.scoreDetails,
  newScoreDetails: state.ioc.newScoreDetails,
});

const mapDispatchToProps = {
  loadScoreDetails,
  loadNewScoreDetails,
  toggleFalsePositive,
  toggleTruePositive,
  exportSingleIOC,
};

export default connect(mapStateToProps, mapDispatchToProps)(IOC);
